// extracted by mini-css-extract-plugin
export default {"PrintTicketContainer":"PrintTicket_PrintTicketContainer__XTuzo","PrintTicketWrapper":"PrintTicket_PrintTicketWrapper__Jvq2U","backBtnContainer":"PrintTicket_backBtnContainer__H0YqZ"};